module.exports = __webpack_public_path__ + "img/tj1.529fdcb0.png";